import * as React from 'react';
import { Link, NavLink } from 'react-router-dom';

export class NavMenu extends React.Component<{}, {}> {
    public render() {
        return <div className='main-nav'>
                <div className='navbar navbar-inverse'>
                <div className='navbar-header'>
                    <button type='button' className='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse'>
                        <span className='sr-only'>Toggle navigation</span>
                        <span className='icon-bar'></span>
                        <span className='icon-bar'></span>
                        <span className='icon-bar'></span>
                    </button>
                    <Link className='navbar-brand' to={ '/' }>Coherent PDFService</Link>
                </div>
                <div className='clearfix'></div>
                <div className='navbar-collapse collapse'>
                    <ul className='nav navbar-nav'>
                        <li>
                            <NavLink to={ '/' } exact activeClassName='active'>
                                <span className='glyphicon glyphicon-home'></span> Home
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={ '/generatepdf' } activeClassName='active'>
                                <span className='glyphicon glyphicon-th-list'></span> Generate PDF
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={'/pdffields'} activeClassName='active'>
                                <span className='glyphicon glyphicon-list'></span> Get PDF Fields
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={'/usagedetails'} activeClassName='active'>
                                <span className='glyphicon glyphicon-list'></span> Usage Details
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/NavMenu.tsx